import { AxiosInstance, AxiosResponse } from 'axios';
import { JwtResponse, LoginRequest, RegisterRequest, User } from '../../types';

export class AuthApi {
  constructor(private readonly http: AxiosInstance) {}

  async login(credentials: LoginRequest): Promise<JwtResponse> {
    const response: AxiosResponse<JwtResponse> = await this.http.post('/auth/login', credentials);
    return response.data;
  }

  async register(userData: RegisterRequest): Promise<void> {
    await this.http.post('/auth/register', userData);
  }

  async logout(): Promise<void> {
    await this.http.post('/auth/logout');
  }

  async refresh(): Promise<JwtResponse> {
    const response: AxiosResponse<JwtResponse> = await this.http.post('/auth/refresh');
    return response.data;
  }

  async currentUser(): Promise<User> {
    const response: AxiosResponse<User> = await this.http.get('/auth/me');
    return response.data;
  }

  async forgotPassword(email: string): Promise<{ message: string }> {
    const response: AxiosResponse<{ message: string }> = await this.http.post('/auth/forgot-password', { email });
    return response.data;
  }

  async resendVerification(email: string): Promise<{ message: string }> {
    const response: AxiosResponse<{ message: string }> = await this.http.post('/auth/resend-verification', null, {
      params: { email },
    });
    return response.data;
  }

  async resetPassword(token: string, newPassword: string): Promise<{ message: string }> {
    const response: AxiosResponse<{ message: string }> = await this.http.post('/auth/reset-password', {
      token,
      newPassword,
    });
    return response.data;
  }
}
